import { ActionTransactionSubType } from '../action';
import { CurrencyCode, FxDataFeed } from '../vehicle';

export enum TransactionOperation {
  Credit = 'Credit',
  Debit = 'Debit',
}

export interface CurrencyRateDetails {
  fetchedRate?: number;
  fetchedSource?: FxDataFeed;
  overrideRate?: number;
  overrideSource?: string;
}
export enum CounterpartyRef {
  Investor = 'investor',
  Contact = 'contact',
  Asset = 'asset',
  Vehicle = 'vehicle',
}

export interface TransactionDetails {
  id?: string;
  transactionTypeId: string;
  amountExVatLcy?: number | null;
  amountIncVatLcy?: number | null;
  amountExVatTcy: number;
  amountIncVatTcy: number;
  transactionCurrency: CurrencyCode;
  operationType: TransactionOperation;
  transactionSubType: ActionTransactionSubType;
}
